import { validate } from 'ember-validators';

export function isNumber(val: any): boolean {
  let result = validate('number', val, { allowString: true, allowNone: false });
  return result === true;
}

// replaces characters with accents with only the character.
// 'Jõè' bcomes 'Joe'
export function normalizeAccentCharacters(val: string): string {
  if (typeof val === 'string') {
    return val.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  }
  return val;
}
